import React, { useRef, useState, useEffect } from 'react';
import { Upload, Button, Tooltip } from 'antd';
import { PaperClipOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import { uploadFile } from '../../utils/uploadFile';

export const MAX_ATTACHMENTS = 5;

export default function CommentAttachmentInput({ value = [], onChange, disabled }) {
  const list = Array.isArray(value) ? value : [];
  const listRef = useRef(list);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    listRef.current = list;
  }, [list]);

  const handleFile = async (file) => {
    if (disabled || uploading || listRef.current.length >= MAX_ATTACHMENTS) return false;
    setUploading(true);
    try {
      const { url, name, type } = await uploadFile(file);
      const current = listRef.current;
      const next = [...current, { url, name: name || file.name || '', type: type || file.type || '' }].slice(0, MAX_ATTACHMENTS);
      onChange(next);
    } catch (err) {
      console.error('Upload failed', err);
    } finally {
      setUploading(false);
    }
    return false;
  };

  const remove = (index) => {
    const next = list.filter((_, i) => i !== index);
    onChange(next);
  };

  const atLimit = list.length >= MAX_ATTACHMENTS;

  return (
    <div className="comment-attachment-input">
      {atLimit ? (
        <Tooltip title={`Maximum ${MAX_ATTACHMENTS} attachments per comment`}>
          <span>
            <Button type="text" size="small" icon={<PaperClipOutlined />} disabled aria-label="Add attachment (limit reached)" />
          </span>
        </Tooltip>
      ) : (
        <Tooltip title={`Add attachment (up to ${MAX_ATTACHMENTS} per comment)`}>
          <Upload
            accept="image/*,.pdf,.doc,.docx,.txt"
            showUploadList={false}
            beforeUpload={handleFile}
            disabled={disabled || uploading}
          >
            <Button type="text" size="small" icon={uploading ? <LoadingOutlined /> : <PaperClipOutlined />} disabled={uploading} aria-label="Add attachment" />
          </Upload>
        </Tooltip>
      )}
      {list.length > 0 && (
        <span className="comment-attachment-input-list">
          {list.map((att, idx) => (
            <span key={idx} className="comment-attachment-input-item">
              <span className="comment-attachment-input-name" title={att.name}>
                {att.name || `File ${idx + 1}`}
              </span>
              {!disabled && (
                <Button
                  type="text"
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => remove(idx)}
                  aria-label="Remove attachment"
                />
              )}
            </span>
          ))}
        </span>
      )}
    </div>
  );
}
